import type { MissionMembershipRole, ProjectMissionSnapshot, UserAccessSnapshot } from '../../contracts/types'
import { getRegisteredProjectSnapshot } from '../../fixtures/projectSnapshotRegistry'
import { lookupProjectMembershipRole } from '../projectMembershipRegistry'
import { readSessionSurfaceRouteHint } from '../readSessionSurfaceRouteHint'
import type { CommandDeckMissionReadModelReaders } from '../commandDeckMissionReadModel.types'
import { readFirestoreProjectMissionSnapshot } from './firestoreProjectMissionSnapshotReader'

function loadFromReaders(projectId: string): ProjectMissionSnapshot | null {
  try {
    const firestore = readFirestoreProjectMissionSnapshot(projectId)
    if (firestore && firestore.projectId === projectId) return firestore
  } catch {
    // Fail closed — registry explicit entries only.
  }
  return getRegisteredProjectSnapshot(projectId)
}

export const defaultCommandDeckMissionReaders: CommandDeckMissionReadModelReaders = {
  loadProjectSnapshot: loadFromReaders,
  loadMembershipRole: (input: {
    uid?: string
    projectId: string
    access: UserAccessSnapshot
  }): MissionMembershipRole | undefined => lookupProjectMembershipRole(input.projectId, input.uid),
  readSessionSurfaceRouteHint: (input) => readSessionSurfaceRouteHint(input),
}
